// extracted by mini-css-extract-plugin
module.exports = {"list":"_2H9j67"};